export default "__VITE_ASSET__kDSdSdSF__"